'use client';

import { Icon, ScreenContainer } from '@/components/core';
import { Trans } from '@lingui/react/macro';
import { useLocalizedLinks } from '@/components/core/hooks';
import InternalLink from '@/components/core/components/organism/internal-link';
import * as styles from './layout.styles';
import Navbar from './_components/navbar';
import MobileDownloadApp from './_components/mobile-download-app';

const Layout = ({ children }) => {
  const links = useLocalizedLinks();
  return (
    <div className={styles.root}>
      <Navbar className={styles.navbar} />
      <section className={styles.body}>{children}</section>
      <footer className={styles.footer}>
        <ScreenContainer className={styles.footerContainer}>
          <InternalLink className={styles.privacy} href={links.privacyPolicy()}>
            <Trans>Privacy Policy</Trans>
          </InternalLink>
          <span className={styles.social}>
            <a href="https://www.tiktok.com/@peoopleofficial" target="_blank" rel="noopener nofollow">
              <Icon name="tiktok" />
            </a>

            <a href="https://www.instagram.com/peoople/" target="_blank" rel="noopener nofollow">
              <Icon name="instagram" />
            </a>

            <a href="https://www.linkedin.com/company/peoople/" target="_blank" rel="noopener nofollow">
              <Icon name="linkedin" />
            </a>
          </span>
          <span className={styles.copyright}>© {new Date().getFullYear()} Peoople</span>
        </ScreenContainer>
      </footer>
      <MobileDownloadApp />
    </div>
  );
};

export default Layout;
